import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const CHANGED = "delivery-alerts-changed";
export const deliveryAlertsChanged = () => window.dispatchEvent(new Event(CHANGED));

// Open webhook down / failing alerts for the sidebar badge.
export function useDeliveryAlertCount(enabled) {
  const [count, setCount] = useState(0);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    const load = () => api.get("/delivery-alerts/count")
      .then((r) => { if (live) setCount(r.data.open || 0); })
      .catch(() => {});
    load();
    const timer = setInterval(load, 60000);
    window.addEventListener(CHANGED, load);
    return () => {
      live = false;
      clearInterval(timer);
      window.removeEventListener(CHANGED, load);
    };
  }, [enabled, pathname]);
  return count;
}
